export function commonReducer(
  state: any = [],
  action: { type: string; payload: any }
) {
  switch (action.type) {
    case 'LOAD_COMMON_DATA':
      state = action.payload;
      break;
    default:
      return state;
  }
  return Object.assign([], action.payload);
}
